export default __webpack_public_path__ + "static/media/FlyingFrog14.cb1c0baf.png";